import handleError from '@/commons/errorHandler';
import {getCartContext} from '@/store/api';
import cart from '@/store/modules/cart';

export function resetLocalStorageCart() {
    const mageCacheStorage = localStorage.getItem('mage-cache-storage');

    if (mageCacheStorage) {
        try {
            const mageCacheStorageObject = JSON.parse(mageCacheStorage);
            mageCacheStorageObject.cart.items = [];
            mageCacheStorageObject.cart.subtotal = '';
            mageCacheStorageObject.cart.subtotalAmount = 0;
            mageCacheStorageObject.cart.subtotal_excl_tax = '';
            mageCacheStorageObject.cart.subtotal_incl_tax = '';
            mageCacheStorageObject.cart.summary_count = 0;
            localStorage.setItem('mage-cache-storage', JSON.stringify(mageCacheStorageObject));
        } catch (e) {
            // eslint-disable-next-line no-console
            console.log(e);
            handleError(e);
        }
    }
}

export async function addLocalStorageOrder() {
    try {
        const items: any[] = [];

        cart.cart.items.forEach((item) => {
            items.push({
                cartItemId: item.item_id,
                productSku: item.sku,
                productName: item.name,
                qty: item.qty,
                basePrice: item.price,
                offerPrice: item.price,
                mainImageUrl: item.extension_attributes.extproduct_image,
            });
        });

        const dsorderContext = {
            data: {
                cartId: cart.cart.id,
                itemsCount: items.length,
                subtotalExcludingTax: cart.totals.base_subtotal,
                subtotalIncludingTax: cart.totals.subtotal,
                items,
            },
        };

        localStorage.setItem('ds-order-context', JSON.stringify(dsorderContext));

        const cartContext: any = await getCartContext();
        localStorage.setItem('ds-cart-order', JSON.stringify(cartContext));
    } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
        handleError(e);
    }
}
